import React, { useEffect, useState } from "react";
import {
    accountContent,
    sectionHeader,
    sectionHeaderTitle,
    sectionHeaderDescription,
    productsGrid,
    productCard,
    productImageBox,
    productImage,
    productBody,
    productMeta,
    productTitle,
    productActions,
    productButton,
    favoriteButton,
    info,
    error,
} from "./product-favorites.module.scss";
import { IProduct } from "../../../models/product.model";
import {
    getFavoriteProducts,
    removeFavoriteProduct,
} from "../../../services/product-favorites-services";
import favoriteIcon from "../../../assets/icons/favorite.svg";
import emptyFavoritesImage from "../../../assets/images/account/favorites-empty.jpeg";
import Loader from "../../../components/atoms/loader";
import AccountEmptyState from "../molecules/account-empty-state";

export default function ProductFavorites() {
    const [products, setProducts] = useState<IProduct[]>([]);
    const [status, setStatus] = useState<"loading" | "success" | "fail">("loading");
    const [removingId, setRemovingId] = useState<number | null>(null);

    useEffect(() => {
        getFavoriteProducts()
            .then((items) => {
                setProducts(items);
                setStatus("success");
            })
            .catch(() => {
                setStatus("fail");
            });
    }, []);

    const handleRemove = async (productId: number) => {
        setRemovingId(productId);
        try {
            await removeFavoriteProduct(productId);
            setProducts((items) => items.filter((product) => product.productId !== productId));
        } finally {
            setRemovingId(null);
        }
    };

    return (
        <div className={accountContent}>
            {status === "loading" && <Loader position="absolute" />}

            <div className={sectionHeader}>
                <div>
                    <h1 className={sectionHeaderTitle}>Ulubione ciuchy</h1>
                    <p className={sectionHeaderDescription}>
                        Produkty, które oznaczyłaś serduszkiem w stylizacjach.
                    </p>
                </div>
            </div>

            {status === "fail" && (
                <p className={`${info} ${error}`}>Nie udało się pobrać ulubionych produktów.</p>
            )}

            {status === "success" && products.length === 0 && (
                <AccountEmptyState
                    image={emptyFavoritesImage}
                    title="Tu pojawią się Twoje ulubione ciuchy"
                >
                    Klikaj serduszko przy produktach w stylizacjach, a zapiszesz je w tym miejscu.
                </AccountEmptyState>
            )}

            {status === "success" && products.length > 0 && (
                <div className={productsGrid}>
                    {products.map((product) => (
                        <article key={product.productId} className={productCard}>
                            <div className={productImageBox}>
                                {product.imgUrl && (
                                    <img
                                        className={productImage}
                                        src={product.imgUrl}
                                        alt={product.category || product.brandName || "Produkt"}
                                    />
                                )}
                                <button
                                    type="button"
                                    className={favoriteButton}
                                    disabled={removingId === product.productId}
                                    onClick={() => handleRemove(product.productId)}
                                    aria-label="Usuń z ulubionych"
                                >
                                    <img src={favoriteIcon} alt="" aria-hidden="true" />
                                </button>
                            </div>
                            <div className={productBody}>
                                <p className={productMeta}>{product.category || "Produkt"}</p>
                                <h2 className={productTitle}>{product.brandName || "Fashion Fairy"}</h2>
                                <div className={productActions}>
                                    {(product.affiliateUrl || product.url) && (
                                        <a
                                            className={productButton}
                                            href={product.affiliateUrl || product.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Zobacz
                                        </a>
                                    )}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </div>
    );
}
